import React, { forwardRef } from 'react';

import { FiArrowUpCircle } from "react-icons/fi";

const GoToUp = forwardRef(({ goUp }, ref) => {
  return (
    <button className="fixed bottom-5 right-4 md:right-7 z-20 translate-y-20 transition-transform duration-500" ref={ref} onClick={goUp}>
      <FiArrowUpCircle size={32} className="animate-bounce text-main rounded-full" />
    </button>
  );
});

export default GoToUp;
